import { Dispatch, SetStateAction } from 'react';
import { OpportunityDetailsType } from '../opportunity';
import { set } from 'lodash';

export const FIELD_NAMES = {
    lineItemsAreUnsaved: 'lineItemsAreUnsaved',
    resourcesAreUnsaved: 'resourcesAreUnsaved'
};
export const setUnsavedFlags = (
    flags: string[],
    values: OpportunityDetailsType,
    setValues: Dispatch<SetStateAction<OpportunityDetailsType>>,
    ownerOrganizationChanged: boolean
) => {
    const updatedValues = { ...values };
    if (ownerOrganizationChanged) {
        flags.forEach((flag) => {
            set(updatedValues, flag, true);
        });
    }

    setValues({ ...updatedValues, ownerOrganizationChanged });
};

export const getItemsToSave = (ownerOrganizationChanged: boolean, items: any) => {
    if (ownerOrganizationChanged) {
        return items;
    }
    return items.filter((line) => line.isModified);
};

export const mergeKeyActivities = (viewState) => {
    const planKeyRefs = viewState?.plans?.[0]?.keyActivities || [];
    const planActivities = viewState?.plans?.[0]?.activities || [];

    const activitiesById = new Map();
    planActivities.forEach((a) => {
        const id = a?.identity?.id || a?.id;
        if (id) activitiesById.set(id, a);
    });

    return planKeyRefs.map((ref) => {
        const full = activitiesById.get(ref.id);
        if (!full) {
            return { id: ref.id, isKey: true };
        }

        return {
            ...full,
            id: ref.id,
            isKey: true
        };
    });
};

export const filterActivitiesByQuery = (activities, query) => {
    if (!query) return activities;

    const searchWords = query.toLowerCase().split(' ');
    return activities.filter((activity) =>
        searchWords.every(
            (word) =>
                (activity.name?.toLowerCase() || '').includes(word) ||
                (activity.activityType?.toLowerCase() || '').includes(word) ||
                (activity.dateRange?.start?.toString().toLowerCase() || '').includes(word) ||
                (activity.dateRange?.end?.toString().toLowerCase() || '').includes(word)
        )
    );
};
export const handleToggleActivity =
    ({
        viewStateSableRef,
        setViewState,
        saveKeyActivities,
        planId,
        isButtonLoadingRef,
        getKeyActivitiesRefs,
        activityData,
        keyActivities
    }) =>
    async (activityId, type) => {
        const doMark = type === 'mark';

        isButtonLoadingRef.current = { id: activityId, isLoading: true };

        setViewState((prevVal) => ({
            ...prevVal,
            plans: [
                {
                    ...viewStateSableRef.current.plans[0],
                    keyActivities: getKeyActivitiesRefs(
                        activityId,
                        keyActivities,
                        activityData?.results?.hits?.items,
                        doMark
                    )
                }
            ]
        }));

        await saveKeyActivities(
            planId,
            getKeyActivitiesRefs(activityId, keyActivities, activityData?.results?.hits?.items, doMark),
            true
        );

        isButtonLoadingRef.current = { id: '', isLoading: false };
    };
